import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class GetSessionProfileService {

   url_sessionProfile = `${environment.ENTORNO}Services/Session/SessionService.svc/GetCurrentSessionProfile`;

  constructor(private http: HttpClient) { }

  httpOptions = {
    withCredentials: true,
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

sessionProfile(): Observable<any> {
    const applicationType = {applicationType: 0};
     return this.http.post(this.url_sessionProfile, applicationType, this.httpOptions);
   }
}
